// extracted by mini-css-extract-plugin
module.exports = {"section":"team_section__Wn61D","title":"team_title__2Slhd"};